import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";
import isEqual from "lodash/isEqual";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class Link extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (
      !isEqual(currentPayload, nextPayload) ||
      !isEqual(nextProp.settings, this.props.settings)
    ) {
      return true;
    }
    // console.log("re-render");
    return false;
  }

  _initLink = (preview, blockPreview = false) => {
    let { payload, parentID, name } = this.props;

    if (blockPreview || payload === null) {
      payload = this.props.options.payload;
      parentID = "root";
    }

    let linkLabel = (payload.datas && payload.datas["linkLabel"]) || "";

    if (payload.datas && payload.datas["linkLabel_" + this.props.currentLang])
      linkLabel = payload.datas["linkLabel_" + this.props.currentLang];

    const {
      iconClass,
      useIcon,
      iconPosition,
      buttonAnimation,
      buttonFullWidth,
      type,
      iconSpacing,
    } = payload.datas || {};
    let cssSettings = generateStyle(payload, "container");
    let cssSettingsText = generateStyle(payload, "text", "body");
    const normatSettingsText = generateStyle(payload, "text");
    const defafultSettings =
      payload && payload.settings && payload.settings.background;

    const cssAlignment = generateStyle(payload, "alignment");

    if (name === "Button") {
      const buttonStyles = {};
      if (type == "active") {
        buttonStyles.backgroundColor =
          this.props.settings["active_button_color"]?.bgColor ||
          defafultSettings.backgroundColor ||
          "";
        buttonStyles.color =
          this.props.settings["active_button_text_color"]?.color ||
          cssSettingsText.color ||
          "";
      } else if (type == "regular") {
        buttonStyles.backgroundColor =
          this.props.settings["button_color"]?.bgColor ||
          defafultSettings.backgroundColor ||
          "";
        buttonStyles.color =
          this.props.settings["button_text_color"]?.color ||
          cssSettingsText.color ||
          "";
      } else {
        buttonStyles.backgroundColor =
          this.props.settings["button_color"]?.bgColor ||
          defafultSettings.backgroundColor ||
          "";
        buttonStyles.color =
          this.props.settings["button_text_color"]?.color ||
          cssSettingsText.color ||
          "";
      }

      if (!cssSettings.backgroundColor) {
        cssSettings = {
          ...cssSettings,
          ...buttonStyles,
        };
      }

      if (!payload?.settings?.text?.color) {
        cssSettingsText.color = buttonStyles.color;
      }
      if (blockPreview)
        return (
          <>
            <Container fluid={payload.fullContainer}>
              {setOverLay(payload)}
              <Row>
                <Col xs={12} className="fullcol">
                  <div style={cssAlignment}>
                    <span
                      className={`atc-btn b ${
                        buttonAnimation
                          ? buttonAnimation + " infinite-animation"
                          : ""
                      } ${buttonFullWidth ? "full-width" : ""}`}
                      style={cssSettings}
                    >
                      {!preview && <div className="overlay"></div>}
                      <span style={normatSettingsText}>
                        {useIcon &&
                          iconPosition !== "right" &&
                          iconClass &&
                          Array.isArray(iconClass) && (
                            <span
                              className="left"
                              style={{ marginRight: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={[iconClass[0], iconClass[1]]}
                              />
                            </span>
                          )}
                        {useIcon &&
                          iconPosition !== "right" &&
                          iconClass &&
                          !Array.isArray(iconClass) && (
                            <span
                              className="left"
                              style={{ marginRight: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={["fas", iconClass.replace("fa-", "")]}
                              />
                            </span>
                          )}
                        {linkLabel || ""}
                        {useIcon &&
                          iconPosition === "right" &&
                          iconClass &&
                          Array.isArray(iconClass) && (
                            <span
                              className="right"
                              style={{ marginLeft: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={[iconClass[0], iconClass[1]]}
                              />
                            </span>
                          )}
                        {useIcon &&
                          iconPosition === "right" &&
                          iconClass &&
                          !Array.isArray(iconClass) && (
                            <span
                              className="right"
                              style={{ marginLeft: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={["fas", iconClass.replace("fa-", "")]}
                              />
                            </span>
                          )}
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Container>
          </>
        );
      else {
        return (
          <>
            <Container fluid={payload.fullContainer}>
              {setOverLay(payload)}
              <Row>
                <Col xs={12} className="fullcol">
                  <div style={cssAlignment}>
                    <span
                      className={`atc-btn b ${
                        buttonAnimation
                          ? buttonAnimation + " infinite-animation"
                          : ""
                      } ${buttonFullWidth ? "full-width" : ""}`}
                      style={cssSettings}
                    >
                      {!preview && <div className="overlay"></div>}
                      <span style={cssSettingsText}>
                        {useIcon &&
                          iconPosition !== "right" &&
                          iconClass &&
                          Array.isArray(iconClass) && (
                            <span
                              className="left"
                              style={{ marginRight: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={[iconClass[0], iconClass[1]]}
                              />
                            </span>
                          )}
                        {useIcon &&
                          iconPosition !== "right" &&
                          iconClass &&
                          !Array.isArray(iconClass) && (
                            <span
                              className="left"
                              style={{ marginRight: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={["fas", iconClass.replace("fa-", "")]}
                              />
                            </span>
                          )}
                        {linkLabel || ""}
                        {useIcon &&
                          iconPosition === "right" &&
                          iconClass &&
                          Array.isArray(iconClass) && (
                            <span
                              className="right"
                              style={{ marginLeft: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={[iconClass[0], iconClass[1]]}
                              />
                            </span>
                          )}
                        {useIcon &&
                          iconPosition === "right" &&
                          iconClass &&
                          !Array.isArray(iconClass) && (
                            <span
                              className="right"
                              style={{ marginLeft: iconSpacing }}
                            >
                              <FontAwesomeIcon
                                icon={["fas", iconClass.replace("fa-", "")]}
                              />
                            </span>
                          )}
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>
            </Container>
          </>
        );
      }
    }

    if (parentID === "root" && !blockPreview) {
      const settings = this.props.settings;
      const color =
        settings && settings["links_color"] && settings["links_color"].color;
      if (!payload?.settings?.text?.color) {
        cssSettingsText.color = color || cssSettingsText.color;
      }
      return (
        <Container fluid={payload.fullContainer}>
          {setOverLay(payload)}
          <Row>
            <Col xs={12} className="fullcol">
              <div style={cssAlignment}>
                <span
                  className={`atc-btn b ${
                    buttonAnimation
                      ? buttonAnimation + " infinite-animation"
                      : ""
                  } ${buttonFullWidth ? "full-width" : ""}`}
                  style={cssSettings}
                >
                  {!preview && <div className="overlay"></div>}
                  <span style={cssSettingsText}>
                    {useIcon &&
                      iconPosition !== "right" &&
                      iconClass &&
                      Array.isArray(iconClass) && (
                        <span
                          className="left"
                          style={{ marginRight: iconSpacing }}
                        >
                          <FontAwesomeIcon
                            icon={[iconClass[0], iconClass[1]]}
                          />
                        </span>
                      )}
                    {useIcon &&
                      iconPosition !== "right" &&
                      iconClass &&
                      !Array.isArray(iconClass) && (
                        <span
                          className="left"
                          style={{ marginRight: iconSpacing }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", iconClass.replace("fa-", "")]}
                          />
                        </span>
                      )}
                    {linkLabel || ""}
                    {useIcon &&
                      iconPosition === "right" &&
                      iconClass &&
                      Array.isArray(iconClass) && (
                        <span
                          className="right"
                          style={{ marginLeft: iconSpacing }}
                        >
                          <FontAwesomeIcon
                            icon={[iconClass[0], iconClass[1]]}
                          />
                        </span>
                      )}
                    {useIcon &&
                      iconPosition === "right" &&
                      iconClass &&
                      !Array.isArray(iconClass) && (
                        <span
                          className="right"
                          style={{ marginLeft: iconSpacing }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", iconClass.replace("fa-", "")]}
                          />
                        </span>
                      )}
                  </span>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      );
    } else
      return (
        <div style={cssAlignment}>
          {setOverLay(payload)}
          <span
            className={`atc-btn b ${
              buttonAnimation ? buttonAnimation + " infinite-animation" : ""
            } ${buttonFullWidth ? "full-width" : ""}`}
            style={cssSettings}
          >
            {!preview && <div className="overlay"></div>}
            <span style={cssSettingsText}>
              {useIcon &&
                iconPosition !== "right" &&
                iconClass &&
                Array.isArray(iconClass) && (
                  <span className="left" style={{ marginRight: iconSpacing }}>
                    <FontAwesomeIcon icon={[iconClass[0], iconClass[1]]} />
                  </span>
                )}
              {useIcon &&
                iconPosition !== "right" &&
                iconClass &&
                !Array.isArray(iconClass) && (
                  <span className="left" style={{ marginRight: iconSpacing }}>
                    <FontAwesomeIcon
                      icon={["fas", iconClass.replace("fa-", "")]}
                    />
                  </span>
                )}
              {linkLabel || ""}
              {useIcon &&
                iconPosition === "right" &&
                iconClass &&
                Array.isArray(iconClass) && (
                  <span className="right" style={{ marginLeft: iconSpacing }}>
                    <FontAwesomeIcon icon={[iconClass[0], iconClass[1]]} />
                  </span>
                )}
              {useIcon &&
                iconPosition === "right" &&
                iconClass &&
                !Array.isArray(iconClass) && (
                  <span className="right" style={{ marginLeft: iconSpacing }}>
                    <FontAwesomeIcon
                      icon={["fas", iconClass.replace("fa-", "")]}
                    />
                  </span>
                )}
            </span>
          </span>
        </div>
      );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          {(options.showPreview && this._initLink(false, true)) || (
            <span className="dragger">
              {(Array.isArray(rest.icon) && (
                <FontAwesomeIcon icon={rest.icon} />
              )) || <Icon icon={rest.icon} />}
              <span>{l(rest.name)}</span>
            </span>
          )}
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initLink(true, false)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initLink()}
      </Draggable>
    );
  }
}

Link.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Link);
